<script>
	import { Router, Route } from "svelte-routing";
	import Index from "./view/Index.svelte";
	import Shop from "./view/Shop.svelte";
	import About from "./view/About.svelte";
	import Privacy from "./view/Privacy.svelte";
	import Contact from "./view/Contact.svelte";
  
	export let url = "";
  </script>
    <Router url="{url}">
	<Route path="/" component="{Index}" />
	<Route path="/shop" component="{Shop}" />
	<Route path="/about" component="{About}" />
	<Route path="/privacy" component="{Privacy}" />
	<Route path="/contact" component="{Contact}" />
  </Router>
